import React, { Component } from "react"
import CircularProgress from "@material-ui/core/CircularProgress";
import LoginService from "../../services/LoginService";
import Auth from "../../services/AuthService";


class LoginRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true
    }
    this.loginService = new LoginService();
    this.handleAuthenticate = this.handleAuthenticate.bind(this);
  }

  componentDidMount() {
    const queryString = require('query-string');
    const parsed = queryString.parse(window.location.search);
    this.handleAuthenticate(parsed)
  }

  async handleAuthenticate(code) {
    this.setState({
      isLoaded: true
    });
    const { history } = this.props;
    const resp = await this.loginService.doLogin(code.code);
    if (resp.hasOwnProperty("status") && resp.status === "error") {

      this.setState({
        isLoaded: false
      });

      history.push("/");
      return null;
    }

    await Auth.login(resp);
    console.log("logou")
    window.location.href = "/home"
    return null;
  }


  render() {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}>
        <div style={{ marginTop: '80px' }}>
          <CircularProgress disableShrink />
        </div>
      </div>
    );
  }

}

export default LoginRedirect;